import type { SanityPageBuilderLogoWallSection, SanityPageBuilderSection } from "@ouster/shared";
import { LogoWallBlockView } from "~/features/blocks/inventory/logo-wall";
import { Asset, type Props as AssetProps } from "~/features/craft/asset";
import { toCraftAsset, type CraftAsset } from "~/features/sanity/media";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderLogoWallSection;
  };
};
export function SanityLogoWallSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const gallery = sectionContent.gallery?.map(item => toCraftAsset(item)).filter((asset): asset is CraftAsset => Boolean(asset)) ?? [];
  return <LogoWallBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} gallery={gallery} getLogoKey={(_logo, index) => index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} isHighlighted={sectionContent.isHighlighted} mode={sectionSettings?.mode || "light"} renderLogo={logo => <Asset asset={logo as AssetProps["asset"]} imageProps={{
    fit: "contain",
    rounded: false,
    sizes: "128px lg:240px",
    imgixProps: {
      fit: "max",
      h: 120,
      w: 240
    }
  }} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}